export default __webpack_public_path__ + "static/media/Sprint_mob.55b0523a.png";